var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "row--large"
  }, _vm._l(_vm.items, function (_ref) {
    var text = _ref.text,
      value = _ref.value;
    return _c('v-col', {
      key: text,
      attrs: {
        "cols": "4",
        "lg": "auto"
      }
    }, [_c('v-sheet', [_c('p', {
      staticClass: "page-text--sm grey-9--text mb-4"
    }, [_vm._v(_vm._s(text))]), _c('h5', {
      staticClass: "page-text--lg font-weight-medium"
    }, [_vm._v(_vm._s(value) + "명")])])], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }